import { JourneyLayout } from "@/components/journey/JourneyLayout";
import { VerseDisplay } from "@/components/journey/VerseDisplay";
import { courageVerses } from "@/data/verses";

export default function JourneyCourage() {
  return (
    <JourneyLayout title="Courage">
      <VerseDisplay verses={courageVerses} />
    </JourneyLayout>
  );
}